 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","dettaglio-dashboard-dettaglio-dashboard-module":"dettaglio-dashboard-dettaglio-dashboard-module","core-hateoas-example-hateoas-example-module":"core-hateoas-example-hateoas-example-module","core-login-login-module":"core-login-login-module","core-password-reset-password-reset-module":"core-password-reset-password-reset-module","core-reset-password-reset-password-module":"core-reset-password-reset-password-module","operatori-operatori-home-module":"operatori-operatori-home-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","responsabili-responsabili-home-module":"responsabili-responsabili-home-module","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","interni-pages-inventario-inventario-module":"interni-pages-inventario-inventario-module","storico-storico-module":"storico-storico-module","default~attivita-attivita-module~insert-edit-insert-edit-module~pages-insert-edit-contratto-insert-e~7323e36a":"default~attivita-attivita-module~insert-edit-insert-edit-module~pages-insert-edit-contratto-insert-e~7323e36a","attivita-attivita-module":"attivita-attivita-module","default~creazione-flotta-creazione-flotta-module~interni-pages-creazione-flotta-creazione-flotta-module":"default~creazione-flotta-creazione-flotta-module~interni-pages-creazione-flotta-creazione-flotta-module","home-home-module":"home-home-module","interni-interni-module":"interni-interni-module","interni-pages-servizi-interni-servizi-interni-module":"interni-pages-servizi-interni-servizi-interni-module","pages-dettaglio-rendiconto-dettaglio-rendiconto-module":"pages-dettaglio-rendiconto-dettaglio-rendiconto-module","pages-anagrafiche-anagrafiche-module":"pages-anagrafiche-anagrafiche-module","pages-articoli-articoli-module":"pages-articoli-articoli-module","pages-configurazioni-configurazioni-module":"pages-configurazioni-configurazioni-module","pages-contratti-contratti-module":"pages-contratti-contratti-module","pages-dipendenti-dipendenti-module":"pages-dipendenti-dipendenti-module","pages-flusso-dylog-flusso-dylog-module":"pages-flusso-dylog-flusso-dylog-module","pages-gestione-flotta-gestione-flotta-module":"pages-gestione-flotta-gestione-flotta-module","pages-gestione-rendiconti-gestione-rendiconti-module":"pages-gestione-rendiconti-gestione-rendiconti-module","pages-gestione-veicoli-gestione-veicoli-module":"pages-gestione-veicoli-gestione-veicoli-module","pages-gestione-ztl-gestione-ztl-module":"pages-gestione-ztl-gestione-ztl-module","pages-marche-modelli-marche-modelli-module":"pages-marche-modelli-marche-modelli-module","pages-prenotazioni-prenotazioni-module":"pages-prenotazioni-prenotazioni-module","pages-report-report-module":"pages-report-report-module","pages-servizi-servizi-module":"pages-servizi-servizi-module","pages-situazione-economica-situazione-economica-module":"pages-situazione-economica-situazione-economica-module","pages-tariffe-tariffe-module":"pages-tariffe-tariffe-module","default~apertura-inventario-apertura-inventario-module~insert-edit-details-insert-edit-details-modul~e3b2d7a7":"default~apertura-inventario-apertura-inventario-module~insert-edit-details-insert-edit-details-modul~e3b2d7a7","default~insert-edit-details-insert-edit-details-module~pages-dipendenti-insert-edit-details-insert-e~89412ab7":"default~insert-edit-details-insert-edit-details-module~pages-dipendenti-insert-edit-details-insert-e~89412ab7","default~insert-edit-insert-edit-module~insert-edit-rendiconto-insert-edit-rendiconto-module~pages-ed~305a4de3":"default~insert-edit-insert-edit-module~insert-edit-rendiconto-insert-edit-rendiconto-module~pages-ed~305a4de3","pages-gestione-trasferimenti-gestione-trasferimenti-module":"pages-gestione-trasferimenti-gestione-trasferimenti-module","pages-foglio-firma-foglio-firma-module":"pages-foglio-firma-foglio-firma-module","pages-servizio-servizio-module":"pages-servizio-servizio-module","pages-tariffa-tariffa-module":"pages-tariffa-tariffa-module","pages-fast-check-in-fast-check-in-module":"pages-fast-check-in-fast-check-in-module","pages-ingresso-auto-ingresso-auto-module":"pages-ingresso-auto-ingresso-auto-module","pages-profilo-profilo-module":"pages-profilo-profilo-module","pages-accettazione-accettazione-module":"pages-accettazione-accettazione-module","pages-dashboard-dashboard-module":"pages-dashboard-dashboard-module","pages-gestione-gruppi-gestione-gruppi-module":"pages-gestione-gruppi-gestione-gruppi-module","pages-lista-servizi-lista-servizi-module":"pages-lista-servizi-lista-servizi-module","pages-notifications-notifications-module":"pages-notifications-notifications-module","pages-secondo-step-secondo-step-module":"pages-secondo-step-secondo-step-module","pages-servizi-cliente-servizi-cliente-module":"pages-servizi-cliente-servizi-cliente-module","interni-pages-flotta-flotta-module":"interni-pages-flotta-flotta-module","apertura-inventario-apertura-inventario-module":"apertura-inventario-apertura-inventario-module","pages-clienti-clienti-module":"pages-clienti-clienti-module","default~insert-edit-insert-edit-module~pages-insert-edit-contratto-insert-edit-contratto-module":"default~insert-edit-insert-edit-module~pages-insert-edit-contratto-insert-edit-contratto-module","insert-edit-insert-edit-module":"insert-edit-insert-edit-module","insert-edit-details-articoli-insert-edit-details-articoli-module":"insert-edit-details-articoli-insert-edit-details-articoli-module","default~pages-insert-edit-cliente-insert-edit-cliente-module~pages-insert-edit-contratto-insert-edit~5b3e6cc1":"default~pages-insert-edit-cliente-insert-edit-cliente-module~pages-insert-edit-contratto-insert-edit~5b3e6cc1","default~insert-edit-details-insert-edit-details-module~pages-insert-edit-contratto-insert-edit-contr~c87ff1d7":"default~insert-edit-details-insert-edit-details-module~pages-insert-edit-contratto-insert-edit-contr~c87ff1d7","pages-insert-edit-contratto-insert-edit-contratto-module":"pages-insert-edit-contratto-insert-edit-contratto-module","insert-edit-details-insert-edit-details-module":"insert-edit-details-insert-edit-details-module","insert-edit-rendiconto-insert-edit-rendiconto-module":"insert-edit-rendiconto-insert-edit-rendiconto-module","modelli-modelli-module":"modelli-modelli-module","link-report-link-report-module":"link-report-link-report-module","pages-edit-details-edit-details-module":"pages-edit-details-edit-details-module","pages-insert-edit-cliente-insert-edit-cliente-module":"pages-insert-edit-cliente-insert-edit-cliente-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
